/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
import { useState, useEffect, useMemo } from "react";
import { IoLocation } from "react-icons/io5";
import { GENERAL } from "../../constants";
import { useAuthContext } from "../../context/auth";
import { getEdificios } from "../../utils";
import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";
import "./stylesMapa.scss";

export const Mapa2 = () => {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [edificios, setEdificios] = useState(null);
  const { pais } = useAuthContext();

  const localString = (pais) =>
    ({
      Chile: "es-CL",
      Perú: "es-PE",
      Uruguay: "es-UY",
    })[pais] || "es-UY";

  const position = useMemo(
    () =>
      ({
        Chile: { lat: -33.43, lng: -70.601 },
        Perú: { lat: -12.14879, lng: -77.01751 },
        Uruguay: { lat: -34.89434, lng: -56.15867 },
      })[pais] || { lat: -12.10979, lng: -77.01751 },
    [pais]
  );

  const CustomInfoBox = ({ title, ascensores, totems, personas, espera, id, estado }) => {
    let imageSrc = null;
    try {
      imageSrc = require(`../../img/edificios/${id}.png`);
    } catch {
      try {
        imageSrc = require(`../../img/edificios/${id}.jpeg`);
      } catch {
        console.warn(`Image not found for edificio ${id} (tried .png and .jpeg)`);
        imageSrc = null;
      }
    }

    return (
      <div
        style={{
          position: "absolute",
          top: "5px",
          right: "5px",
          backgroundColor: "whitesmoke",
          padding: 5,
          borderRadius: 3,
          width: "225px", // Reduced from 350px to half
          border: "1px solid black",
          textAlign: "left",
        }}
      >
        <h2
          style={{
            background: "darkred",
            padding: "4px",
            margin: 0,
            borderRadius: "2px",
            color: "white",
            marginBottom: "8px",
            textAlign: "center",
            fontSize: "12px", // Reduced from implicit default (~16px)
          }}
        >
          {title}
        </h2>
        <p
          style={{
            fontSize: "10px", // Reduced for smaller size
            margin: "4px 0",
          }}
        >
          AFORO:{" "}
          {personas.toLocaleString(localString(pais), {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </p>
        <p
          style={{
            fontSize: "10px", // Reduced for smaller size
            margin: "4px 0",
          }}
        >
          INVENTARIO:
        </p>
        <ul
          style={{
            fontSize: "10px", // Reduced for smaller size
            margin: "4px 0",
            paddingLeft: "15px",
          }}
        >
          {ascensores ? <li>ASCENSORES: {ascensores}</li> : null}
          {totems ? <li>TOTEMS: {totems}</li> : null}
          {espera ? <li>ESPERA: {espera}</li> : null}
        </ul>
        {(estado === "OPERATIVO" || estado === "INSTALACIÓN") &&
          (imageSrc ? (
            <img
              src={imageSrc}
              alt="Edificio"
              style={{
                width: "100%",
                height: "auto",
                marginBottom: "5px",
                borderRadius: "8px", // Reduced from 15px
              }}
            />
          ) : (
            <div
              style={{
                textAlign: "center",
                color: "red",
                fontSize: "10px", // Reduced for smaller size
              }}
            >
              Imagen no disponible
            </div>
          ))}
      </div>
    );
  };

  const getMarkerColor = (estado) => {
    switch (estado) {
      case "STANDBY":
        return "grey";
      case "PRÓXIMO":
        return "blue";
      case "OPERATIVO":
        return "darkred";
      default:
        return "green";
    }
  };

  const sortEdificios = (a, b) => {
    const order = {
      grey: 1,
      blue: 2,
      red: 3,
    };
    return order[getMarkerColor(a.estado)] - order[getMarkerColor(b.estado)];
  };

  const handleMarkerClick = (marker) => setSelectedMarker(marker);

  useEffect(() => {
    const initialize = async () => {
      const newEdificios = await getEdificios({ pais });
      setEdificios(newEdificios);
    };
    initialize();
  }, [pais]);

  return (
    <APIProvider apiKey={GENERAL.GMAP_API_KEY} language="es">
      <div className="Mapa">
        <Map center={position} zoom={13.1} mapId={GENERAL.GMAP_MAP_ID} streetViewControl={false}>
          {edificios &&
            edificios.sort(sortEdificios).map((edificio) => {
              const markerColor = getMarkerColor(edificio.estado);
              const zIndex = markerColor === "grey" ? 2 : markerColor === "blue" ? 1 : 0;
              return (
                <AdvancedMarker
                  key={edificio.id}
                  position={{ lat: edificio.lat, lng: edificio.lng }}
                  onClick={() => handleMarkerClick(edificio)}
                >
                  <IoLocation
                    style={{
                      color: markerColor,
                      fontSize: "30px",
                      zIndex,
                    }}
                  />
                </AdvancedMarker>
              );
            })}
        </Map>
        {selectedMarker && (
          <CustomInfoBox
            ascensores={selectedMarker.pantallas}
            totems={selectedMarker.totems}
            espera={selectedMarker.espera}
            personas={selectedMarker.personas}
            title={selectedMarker.edificio.toUpperCase()}
            id={selectedMarker.id}
            estado={selectedMarker.estado}
          />
        )}
      </div>
    </APIProvider>
  );
};
